export default __webpack_public_path__ + "assets/twitter.5e2365f3.svg";